import { Button, cn } from '@crm/ui';
import { Bell } from 'lucide-react';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  NOTIFICATIONS_ROUTES,
  useMarkAllRead,
  useMarkNotificationRead,
  useNotifications,
  useUnreadCount,
} from '../api';

/**
 * O sino da barra do topo. No celular ele leva direto para a pagina - lista
 * suspensa em tela pequena vira uma segunda tela mal feita.
 */
export function NotificationBell() {
  const navigate = useNavigate();
  const [aberto, setAberto] = useState(false);

  const contador = useUnreadCount();
  const notificacoes = useNotifications({ limit: 10 });
  const marcarLida = useMarkNotificationRead();
  const marcarTodas = useMarkAllRead();

  const total = contador.data?.total ?? 0;

  function abrir(link: string | null, id: string) {
    marcarLida.mutate(id);
    setAberto(false);
    if (link) navigate(link);
  }

  return (
    <div className="relative">
      <Button
        size="icon"
        variant="ghost"
        aria-label={total > 0 ? `${total} notificacoes novas` : 'Notificacoes'}
        onClick={() => {
          if (window.matchMedia('(min-width: 768px)').matches) setAberto((atual) => !atual);
          else navigate(NOTIFICATIONS_ROUTES.LIST);
        }}
      >
        <Bell className="h-5 w-5" />
        {total > 0 ? (
          <span className="absolute -right-0.5 -top-0.5 flex h-4 min-w-4 items-center justify-center rounded-full bg-destructive px-1 text-[10px] font-medium text-white">
            {total > 99 ? '99+' : total}
          </span>
        ) : null}
      </Button>

      {aberto ? (
        <>
          {/* Clicar fora fecha: um dropdown que so fecha no proprio botao
              prende quem clicou em qualquer outro lugar da tela. */}
          <button
            type="button"
            aria-label="Fechar notificacoes"
            className="fixed inset-0 z-40 cursor-default"
            onClick={() => setAberto(false)}
          />

          <div className="absolute right-0 z-50 mt-2 w-80 overflow-hidden rounded-card border border-border bg-card shadow-lg">
            <div className="flex items-center justify-between gap-2 border-b border-border px-3 py-2">
              <span className="text-sm font-medium">Notificacoes</span>
              {total > 0 ? (
                <button
                  type="button"
                  className="text-xs text-primary hover:underline"
                  onClick={() => marcarTodas.mutate()}
                >
                  Marcar todas como lidas
                </button>
              ) : null}
            </div>

            <ul className="max-h-80 divide-y divide-border overflow-y-auto">
              {notificacoes.data?.data.length ? (
                notificacoes.data.data.map((item) => (
                  <li key={item.id}>
                    <button
                      type="button"
                      onClick={() => abrir(item.link, item.id)}
                      className={cn(
                        'w-full px-3 py-2.5 text-left transition-colors hover:bg-muted/60',
                        item.read ? 'opacity-60' : '',
                      )}
                    >
                      <p className="truncate text-sm font-medium">{item.title}</p>
                      <p className="truncate text-xs text-muted-foreground">{item.body}</p>
                    </button>
                  </li>
                ))
              ) : (
                <li className="px-3 py-6 text-center text-sm text-muted-foreground">
                  Nada por aqui
                </li>
              )}
            </ul>

            <button
              type="button"
              className="w-full border-t border-border px-3 py-2 text-sm text-primary hover:bg-muted/60"
              onClick={() => {
                setAberto(false);
                navigate(NOTIFICATIONS_ROUTES.LIST);
              }}
            >
              Ver todas
            </button>
          </div>
        </>
      ) : null}
    </div>
  );
}
